import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * Bottom gutter of the StandardSection
  * Available options: "standard", "mini"
  */
  gutterBottom: PropTypes.oneOf(['standard', 'mini'])
};
var StandardSection = createComponent({
  displayName: 'StandardSection',
  root: 'section',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-standard-section']);
      var _props$gutterBottom = props.gutterBottom,
          gutterBottom = _props$gutterBottom === void 0 ? 'standard' : _props$gutterBottom;
      if (gutterBottom === 'mini') classNameSet.add('swan-standard-section-mini');
      return classNameSet;
    }
  }
});
StandardSection.defaultProps = {
  gutterBottom: 'standard'
};
export { StandardSection };